<template>
  <div
    class="sidebar"
    :data-color="backgroundColor"
    :data-active-color="activeColor"
  >
    <div class="logo">
      <router-link class="simple-text" v-show="$sidebar.isMinimized" to="/"
        >Annuaire</router-link
      >
      <router-link
        class="simple-text logo-normal"
        v-show="!$sidebar.isMinimized"
        to="/"
        >Annuaire</router-link
      >
    </div>
    <div class="sidebar-wrapper" ref="sidebarScrollArea">
      <slot></slot>
      <ul class="nav">
        <slot name="links">
          <sidebar-item
            v-for="(link, index) in sidebarLinksAllowed"
            :key="link.name + index"
            :link="link"
          >
            <sidebar-item
              v-for="(subLink, index) in link.children"
              :key="subLink.name + index"
              :link="subLink"
            ></sidebar-item>
          </sidebar-item>
          <li v-if="isConnected">
            <a :href="supportUrl" target="_blank" rel="noopener">
              <i class="fa fa-life-ring"></i>
              <p>Support</p>
            </a>
          </li>
        </slot>
      </ul>
    </div>
  </div>
</template>
<script>
import 'perfect-scrollbar/dist/css/perfect-scrollbar.css';
import { isAllowed, isConnected } from '@/services/AuthService';
import sidebarLinks from '@/sidebarLinks';
import { mapState } from 'vuex';

export default {
  components: {},
  props: {
    title: {
      type: String,
      default: 'Vue PDP Pro',
      description: 'Sidebar title',
    },
    backgroundColor: {
      type: String,
      default: 'black',
      validator: value => {
        const acceptedValues = ['white', 'brown', 'black'];
        return acceptedValues.indexOf(value) !== -1;
      },
      description: 'Sidebar background color (white|brown|black)',
    },
    activeColor: {
      type: String,
      default: 'success',
      validator: value => {
        const acceptedValues = [
          'primary',
          'info',
          'success',
          'warning',
          'danger',
        ];
        return acceptedValues.indexOf(value) !== -1;
      },
      description:
        'Sidebar active text color (primary|info|success|warning|danger)',
    },
    logo: {
      type: String,
      default: 'static/img/vue-logo.png',
      description: 'Sidebar Logo',
    },
    sidebarLinks: {
      type: Array,
      default: () => [],
      description:
        'Sidebar links. Can be also provided as children components (sidebar-item)',
    },
    autoClose: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    isConnected,
    ...mapState('account', ['token']),
  },
  watch: {
    token(newValue, oldValue) {
      this.getAllowedLinks();
    },
  },
  data() {
    return {
      domains: [],
      sidebarLinksAllowed: sidebarLinks,
      supportUrl: process.env.VUE_APP_SUPPORT_URL,
    };
  },
  provide() {
    return {
      autoClose: this.autoClose,
    };
  },
  methods: {
    isAllowed,
    async initScrollBarAsync() {
      const isWindows = navigator.platform.startsWith('Win');
      if (!isWindows) {
        return;
      }
      const PerfectScroll = await import('perfect-scrollbar');
      PerfectScroll.initialize(this.$refs.sidebarScrollArea);
    },
    getAllowedLinks() {
      this.sidebarLinksAllowed = sidebarLinks.filter(link => {
        if (link.children) {
          link.children = link.children.filter(subLink => isAllowed(subLink));
          return link.children.length > 0;
        }
        return isAllowed(link);
      });
    },
  },
  mounted() {
    this.initScrollBarAsync();
    this.getAllowedLinks();
  },
  beforeDestroy() {
    if (this.$sidebar.showSidebar) {
      this.$sidebar.showSidebar = false;
    }
  },
};
</script>
<style>
@media (min-width: 992px) {
  .navbar-search-form-mobile,
  .nav-mobile-menu {
    display: none;
  }
  .simple-text {
    text-align: center;
  }
}
</style>
